import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  CANCEL_INTERVIEW,
  CANDIDATE_ACCEPT_THEORETICAL,
  CANDIDATE_INTERVIEW_REJECT,
  ENABLE_JOB_APPLICATION,
  GET_AVAILABLE_SLOTS,
  GET_CANDIDATE_THEORETICAL_AVAILABLE,
  GET_CANDIDATE_PRACTICAL_TRAINING_AVAILABLE,
  GET_JOB_APPLICATION,
  GET_JOB_APPLICATION_DETAILS,
  GET_PROFILE_DETAILS,
  INTERVIEW_APPLY,
  JOB_APPLICATION_TIMELINE,
  RESET_JOB_APPLICATION,
  UPDATE_INTERVIEW_ASSESSMENT_PROMOTION,
  VERIFY_ACTION_OTP,
  WITHDRAWN_JOB_APPLICATION,
  CANDIDATE_ACCEPT_PRACTICAL,
  GET_CANDIDATE_TRIAL_OPERATIONS,
  CANDIDATE_ACCEPT_TRIAL_OPERATION
} from "helpers/url_helper"

export const getJobApplication = createAsyncThunk(
  GET_JOB_APPLICATION,
  async payload => {
    const response = await post(GET_JOB_APPLICATION, payload)
    return response
  }
)
export const getJobApplicationDetails = createAsyncThunk(
  GET_JOB_APPLICATION_DETAILS + "GET DETAIL",
  async uuid => {
    const response = await get(`${GET_PROFILE_DETAILS}/${uuid}`)
    return response
  }
)

export const getAvailableSlots = createAsyncThunk(
  GET_AVAILABLE_SLOTS,
  async () => {
    const response = await get(GET_AVAILABLE_SLOTS)
    return response
  }
)

export const interviewApply = createAsyncThunk(
  INTERVIEW_APPLY,
  async payload => {
    const response = await post(INTERVIEW_APPLY, payload)
    return response
  }
)

export const withdrawnJobApplication = createAsyncThunk(
  WITHDRAWN_JOB_APPLICATION,
  async () => {
    const response = await get(WITHDRAWN_JOB_APPLICATION)
    return response
  }
)

export const enableJobApplication = createAsyncThunk(
  ENABLE_JOB_APPLICATION,
  async () => {
    const response = await get(ENABLE_JOB_APPLICATION)
    return response
  }
)

export const cancelInterview = createAsyncThunk(
  CANCEL_INTERVIEW,
  async payload => {
    const response = await post(CANCEL_INTERVIEW, payload)
    return response
  }
)

export const getJobApplicationTimeline = createAsyncThunk(
  JOB_APPLICATION_TIMELINE,
  async () => {
    const response = await get(JOB_APPLICATION_TIMELINE)
    return response
  }
)

export const verifyActionOtp = createAsyncThunk(
  VERIFY_ACTION_OTP,
  async payload => {
    const response = await post(VERIFY_ACTION_OTP, payload)
    return response
  }
)

export const getCandidateTheoreticalAvailable = createAsyncThunk(
  GET_CANDIDATE_THEORETICAL_AVAILABLE,
  async () => {
    const response = await get(GET_CANDIDATE_THEORETICAL_AVAILABLE)
    return response
  }
)

export const getCandidatePracticalTrainingAvailable = createAsyncThunk(
  GET_CANDIDATE_PRACTICAL_TRAINING_AVAILABLE,
  async () => {
    const response = await get(GET_CANDIDATE_PRACTICAL_TRAINING_AVAILABLE)
    return response
  }
)

export const candidateAcceptTheoretical = createAsyncThunk(
  CANDIDATE_ACCEPT_THEORETICAL,
  async payload => {
    const response = await post(CANDIDATE_ACCEPT_THEORETICAL, payload)
    return response
  }
)
export const candidateAcceptPractical = createAsyncThunk(
  CANDIDATE_ACCEPT_PRACTICAL,
  async payload => {
    const response = await post(CANDIDATE_ACCEPT_PRACTICAL, payload)
    return response
  }
)

export const candidateInterviewReject = createAsyncThunk(
  CANDIDATE_INTERVIEW_REJECT,
  async payload => {
    const response = await post(CANDIDATE_INTERVIEW_REJECT, payload)
    return response
  }
)

export const resetJobApplication = createAsyncThunk(
  RESET_JOB_APPLICATION,
  async uuid => {
    const response = await get(`${RESET_JOB_APPLICATION}/${uuid}`)
    return response
  }
)

export const updateJobApplicationPromotion = createAsyncThunk(
  UPDATE_INTERVIEW_ASSESSMENT_PROMOTION,
  async payload => {
    const response = await post(UPDATE_INTERVIEW_ASSESSMENT_PROMOTION, payload)
    return response
  }
)

export const getCandidateTrialOperations = createAsyncThunk(
  GET_CANDIDATE_TRIAL_OPERATIONS,
  async () => {
    const response = await get(GET_CANDIDATE_TRIAL_OPERATIONS)
    return response
  }
)

export const candidateAcceptTrialOperation = createAsyncThunk(
  CANDIDATE_ACCEPT_TRIAL_OPERATION,
  async payload => {
    const response = await post(CANDIDATE_ACCEPT_TRIAL_OPERATION, payload)
    return response
  }
)

